<template>
  <CreateTransaction v-if="!accounts.dirty && !account_groups.dirty"
                     class="shadow-primaryBlock mb-8 lg:mb-12"
                     ref="createTransaction"
                     :default-form-is-closed="true"
                     :sync-banks-available="false"
                     :transaction-type="transactionType"
                     :transaction-options-list="transactionOptions"
                     :initial-date="transactionDate"
                     @changeType="setType($event)"
                     @toggleOption="setOption($event)"
                     @success="handleSuccessCreating"/>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import CreateTransaction from "@/components/common/CreateTransaction/CreateTransaction";

export default {
  name: "AddOperationWidget",
  components: {CreateTransaction},
  data() {
    return {
      transactionDate: null
    }
  },
  computed: {
    ...mapState('space/accounts', ['accounts', 'account_groups']),
    ...mapState('moneyDashboard/addOperation', ['transactionType', 'transactionOptions']),
  },
  methods: {
    ...mapMutations('moneyDashboard/addOperation', ['setType', 'setOption']),
    handleSuccessCreating() {
      let date = this.$moment(this.$refs.createTransaction.date,'YYYY-MM-DD').unix(),
          today = this.$moment().startOf('day').unix();
      if (date < today) {
        this.$cookies.set(
            'trans_date',
            `${this.$refs.createTransaction.date} ${this.$moment().format('HH:mm')}`,
            60 * 15
        );
      } else {
        this.$cookies.remove('trans_date');
      }
      this.$emit('updateDashboard');
    }
  },
  created() {
    if (!!this.$cookies.get('trans_date')) {
      let date_time = this.$cookies.get('trans_date').split(' ');
      this.transactionDate = date_time[0];
    } else {
      this.transactionDate = this.$moment().format('YYYY-MM-DD');
    }
  }
}
</script>